module.exports = __webpack_public_path__ + "static/media/CaretDoubleDown.8fc34975.svg";